import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      fill="currentColor"
      d="M1.5 12.5h1.063l7.812-7.812-1.062-1.063L1.5 11.438zM.754 14a.74.74 0 0 1-.535-.214.72.72 0 0 1-.219-.532v-1.81q0-.298.104-.569t.334-.5L10.375.438A1.44 1.44 0 0 1 11.435 0q.294 0 .565.104t.5.334L13.563 1.5q.228.23.333.5.104.27.104.553 0 .3-.105.574-.105.272-.332.498l-9.938 9.938q-.23.228-.499.333a1.6 1.6 0 0 1-.567.104zm9.08-9.834-.521-.541 1.062 1.063z"
    />
  </svg>
);
export default SvgStreamlineEdit;
